import React from 'react';

interface GlassOptionCardProps {
  selected: boolean;
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
}

/** A choice on an onboarding step. Selected reads as an ink edge on a wash, not a glow. */
export function GlassOptionCard({
  selected,
  onClick,
  children,
  className = '',
}: GlassOptionCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={selected}
      className={`cursor-pointer rounded-[14px] border p-5 text-left text-ink transition-colors duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-signal ${
        selected ? 'border-ink bg-wash' : 'border-line bg-paper-raised hover:bg-wash'
      } ${className}`}
    >
      {children}
    </button>
  );
}
